"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SHOW_MODAL = exports.SHOW_MODAL = "SHOW_MODAL";
var HIDE_MODAL = exports.HIDE_MODAL = "HIDE_MODAL"; // file system

var LOAD_FILE_OPTIONS = exports.LOAD_FILE_OPTIONS = "LOAD_FILE_OPTIONS";
var SET_FILE_OPTIONS = exports.SET_FILE_OPTIONS = "SET_FILE_OPTIONS";
var SET_FILE_OPTIONS_ERROR = exports.SET_FILE_OPTIONS_ERROR = "SET_FILE_OPTIONS_ERROR";
var HANDLE_INPUT_ERROR = exports.HANDLE_INPUT_ERROR = "HANDLE_INPUT_ERROR";
var SET_CHOSEN = exports.SET_CHOSEN = "SET_CHOSEN";
var FILTER_CHARACTERS = exports.FILTER_CHARACTERS = "FILTER_CHARACTERS";